export default __webpack_public_path__ + "static/media/FeaturedEventsIcon5.48c581d1.png";